import { ReactNode, useEffect } from 'react';
import { LoadingStatuses } from '@packages/shared/core/common/entities';
import { useLogger, useServices } from '@packages/shared/core/common/hooks';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import { EmailConsentStepData, QuizScreenProps } from '@packages/shared/core/quiz/entities';
import { ApiError, UnknownError } from '@packages/shared/core/common/errors';

type EmailConsentQuizStepProps = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const EmailConsentQuizStep = ({ id, renderQuizScreen }: EmailConsentQuizStepProps) => {
  const logger = useLogger();
  const { analyticsService } = useServices();
  const { back, stepData, userPreferences, updateUserSettings, totalSteps, stepOrder, next } = useQuizStep(id);

  const goBack = async () => back();

  const goNext = () => next();

  const handleSubmit = async (isAgree: boolean) => {
    try {
      analyticsService.registrationEmailConsentClick(isAgree);
      await updateUserSettings(isAgree);
    } catch (err) {
      const error = err instanceof ApiError ? err : new UnknownError(err);
      logger.error(error);
    }
  };

  useEffect(() => {
    if (
      userPreferences.emailUpdateStatus === LoadingStatuses.FULFILLED &&
      userPreferences.signUpByFacebookStatus === LoadingStatuses.FULFILLED
    ) {
      goNext();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userPreferences.email, userPreferences.emailUpdateStatus, userPreferences.signUpByFacebookStatus]);

  return (
    <>
      {renderQuizScreen({
        onBack: goBack,
        onSubmit: handleSubmit,
        totalSteps,
        stepOrder,
        goNext,
        ...(stepData as EmailConsentStepData),
      })}
    </>
  );
};

export default EmailConsentQuizStep;
